(function () {
  var EXTRAS_SECTION = 'minicart-extras';
  var refreshing = false;
  var DRAG_THRESHOLD = 40;

  function getTrack(carousel) {
    return carousel.querySelector('.minicart-upsell__track');
  }

  function getSlides(carousel) {
    var track = getTrack(carousel);
    if (!track) return [];
    return Array.prototype.filter.call(track.children, function (child) {
      return child.classList && child.classList.contains('minicart-upsell__slide');
    });
  }

  function getSlideStep(carousel) {
    var slides = getSlides(carousel);
    var track = getTrack(carousel);
    if (!slides.length || !track) return 0;

    var gap = 0;
    if (window.getComputedStyle) {
      gap = parseFloat(window.getComputedStyle(track).columnGap || window.getComputedStyle(track).gap) || 0;
    }

    return slides[0].offsetWidth + gap;
  }

  function goToSlide(carousel, index, animate) {
    var slides = getSlides(carousel);
    var track = getTrack(carousel);
    if (!slides.length || !track) return;

    var safeIndex = Math.max(0, Math.min(index, slides.length - 1));
    carousel.dataset.activeIndex = String(safeIndex);

    var offset = -safeIndex * getSlideStep(carousel);
    track.style.transition = animate === false ? 'none' : 'transform 0.28s ease';
    track.style.transform = 'translate3d(' + offset + 'px, 0, 0)';

    slides.forEach(function (slide, i) {
      var active = i === safeIndex;
      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', active ? 'false' : 'true');
    });

    var dots = carousel.querySelectorAll('.minicart-upsell__dot');
    dots.forEach(function (dot, i) {
      var active = i === safeIndex;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-current', active ? 'true' : 'false');
    });
  }

  function buildDots(carousel, count) {
    var existing = carousel.querySelector('.minicart-upsell__dots');
    if (existing) existing.remove();
    if (count < 2) return;

    var dots = document.createElement('div');
    dots.className = 'minicart-upsell__dots';
    dots.setAttribute('role', 'tablist');
    dots.setAttribute('aria-label', 'Produtos do kit');

    for (var i = 0; i < count; i += 1) {
      (function (index) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'minicart-upsell__dot';
        button.setAttribute('aria-label', 'Ir para produto ' + (index + 1));
        button.addEventListener('click', function () {
          goToSlide(carousel, index, true);
        });
        dots.appendChild(button);
      })(i);
    }

    carousel.appendChild(dots);
  }

  function bindDrag(carousel) {
    if (carousel.dataset.dragBound === 'true') return;
    carousel.dataset.dragBound = 'true';

    var track = getTrack(carousel);
    if (!track) return;

    var pointerId = null;
    var startX = 0;
    var deltaX = 0;
    var dragging = false;
    var startIndex = 0;

    function onPointerDown(event) {
      if (event.target.closest('button, a, input, label')) return;
      if (getSlides(carousel).length < 2) return;

      pointerId = event.pointerId;
      startX = event.clientX;
      deltaX = 0;
      dragging = true;
      startIndex = parseInt(carousel.dataset.activeIndex || '0', 10) || 0;
      track.style.transition = 'none';
      carousel.classList.add('is-dragging');

      if (carousel.setPointerCapture) {
        carousel.setPointerCapture(pointerId);
      }
    }

    function onPointerMove(event) {
      if (!dragging || event.pointerId !== pointerId) return;
      deltaX = event.clientX - startX;
      var offset = (-startIndex * getSlideStep(carousel)) + deltaX;
      track.style.transform = 'translate3d(' + offset + 'px, 0, 0)';
    }

    function onPointerUp(event) {
      if (!dragging || event.pointerId !== pointerId) return;
      dragging = false;
      carousel.classList.remove('is-dragging');

      var nextIndex = startIndex;
      var didSwipe = Math.abs(deltaX) >= DRAG_THRESHOLD;
      if (deltaX <= -DRAG_THRESHOLD) nextIndex = startIndex + 1;
      else if (deltaX >= DRAG_THRESHOLD) nextIndex = startIndex - 1;

      goToSlide(carousel, nextIndex, true);

      if (didSwipe) {
        carousel.dataset.suppressClick = 'true';
        setTimeout(function () {
          delete carousel.dataset.suppressClick;
        }, 0);
      }

      pointerId = null;
      deltaX = 0;
    }

    carousel.addEventListener('click', function (event) {
      if (carousel.dataset.suppressClick === 'true') {
        event.preventDefault();
        event.stopPropagation();
      }
    }, true);

    carousel.addEventListener('pointerdown', onPointerDown);
    carousel.addEventListener('pointermove', onPointerMove);
    carousel.addEventListener('pointerup', onPointerUp);
    carousel.addEventListener('pointercancel', onPointerUp);
  }

  function mountCarousel(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var carousels = scope.querySelectorAll
      ? scope.querySelectorAll('.js-minicart-upsell-carousel')
      : [];

    carousels.forEach(function (carousel) {
      if (carousel.dataset.carouselReady === 'true') return;

      var slides = getSlides(carousel);
      if (!slides.length) return;

      carousel.classList.toggle('is-static', slides.length < 2);
      buildDots(carousel, slides.length);
      bindDrag(carousel);
      goToSlide(carousel, 0, false);
      carousel.dataset.carouselReady = 'true';
    });
  }

  function bindUpsellForms(root) {
    var forms = (root || document).querySelectorAll('.js-minicart-upsell-form');
    forms.forEach(function (form) {
      if (form.dataset.bound === 'true') return;
      form.dataset.bound = 'true';

      var button = form.querySelector('.minicart-upsell__add');
      if (!button) return;

      button.addEventListener('click', function () {
        if (button.disabled) return;
        button.disabled = true;

        var idInput = form.querySelector('input[name="id"]');
        var qtyInput = form.querySelector('input[name="quantity"]');
        var payload = {
          id: idInput ? idInput.value : '',
          quantity: qtyInput ? qtyInput.value : 1
        };

        if (typeof ShopifyAPI !== 'undefined' && typeof ShopifyAPI.addItemFromForm === 'function' && window.jQuery) {
          var $tempForm = window.jQuery('<form>');
          window.jQuery('<input>', { type: 'hidden', name: 'id', value: payload.id }).appendTo($tempForm);
          window.jQuery('<input>', { type: 'hidden', name: 'quantity', value: payload.quantity }).appendTo($tempForm);

          ShopifyAPI.addItemFromForm(
            $tempForm[0],
            function () {
              if (window.ajaxCart && typeof ajaxCart.load === 'function') {
                ajaxCart.load();
              }
              button.disabled = false;
            },
            function () {
              button.disabled = false;
            }
          );
        } else {
          button.disabled = false;
        }
      });
    });
  }

  function refreshUpsellUi(host) {
    if (!host) return;
    mountCarousel(host);
    bindUpsellForms(host);
  }

  function refreshExtras(cart) {
    if (refreshing) return;
    refreshing = true;

    var root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
    var url = root + '?sections=' + EXTRAS_SECTION;

    fetch(url)
      .then(function (response) { return response.json(); })
      .then(function (data) {
        var html = data[EXTRAS_SECTION];
        if (!html) return;

        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var next = doc.querySelector('#MinicartExtrasInner') || doc.querySelector('.minicart-extras');
        if (!next) return;

        var progressHost = document.querySelector('[data-minicart-progress-host]');
        var upsellHost = document.querySelector('[data-minicart-upsell-host]');
        var nextProgress = next.querySelector('[data-minicart-progress]');
        var nextUpsell = next.querySelector('[data-minicart-upsell-root]');

        if (progressHost && nextProgress) {
          if (!cart || cart.item_count === 0) {
            progressHost.innerHTML = '';
          } else {
            progressHost.innerHTML = nextProgress.innerHTML;
          }
        }
        if (upsellHost && nextUpsell) {
          if (!cart || cart.item_count === 0) {
            upsellHost.innerHTML = '';
          } else {
            upsellHost.innerHTML = nextUpsell.innerHTML;
            refreshUpsellUi(upsellHost);
          }
        }

        var shipping = document.querySelector('[data-minicart-shipping]');
        if (shipping) {
          shipping.classList.toggle('is-empty', !cart || cart.item_count === 0);
        }

        document.querySelectorAll('.js-cart-draw').forEach(function (drawer) {
          drawer.classList.toggle('is-cart-empty', !cart || cart.item_count === 0);
        });
      })
      .catch(function () {})
      .finally(function () {
        refreshing = false;
      });
  }

  document.addEventListener('DOMContentLoaded', function () {
    refreshUpsellUi(document.querySelector('[data-minicart-upsell-host]'));

    if (window.jQuery) {
      jQuery(document.body).on('afterCartLoad.ajaxCart', function (event, cart) {
        refreshExtras(cart);
      });

      jQuery(document).on('mfpOpen', function () {
        setTimeout(function () {
          refreshUpsellUi(document.querySelector('[data-minicart-upsell-host]'));
        }, 50);
      });
    }
  });

  window.themeMinicartRefresh = refreshExtras;
})();
